import { Unit, UNITS_QUERY_KEY } from './useUnits';
import { createCrudHooks } from '../utils/createCrudHooks';

const { useCreate, useUpdate, useDelete } = createCrudHooks<Unit>({
  endpoint: '/api/units',
  queryKey: UNITS_QUERY_KEY,
  getId: u => u.unitid,
});

export const useCreateUnit = useCreate;
export const useUpdateUnit = useUpdate;
export const useDeleteUnit = useDelete;
